import { clsx } from 'clsx';
import React, { ReactNode } from 'react';

import { Button, Icon } from '@common/components';

/**
 * Legacy status pill (styled `Button`).
 *
 * @deprecated Use `StatusPill` from `@common/components` for new UI instead of this component.
 */
// TODO: When this component is removed (all call sites on StatusPill), delete
// app/javascript/works/assets/css/utils/button-color.less with it — the
// `button-<color>` classes it applies below are defined there and have no
// other consumer.
export const DeprecatedStatePill = ({
  dropdown,
  color,
  fontSize,
  capitalized = false,
  children,
  className,
  ...other // for compatibility reasons. however, this is not typed (or rather, typed as {})
}: {
  children?: ReactNode | undefined;
  fontSize?: string;
  // TODO: fix this color prop to use ColorsType
  // example: coralHyperlight instead of coral-hyperlight
  // WORK-705
  // https://app.asana.com/1/303134204339906/project/1210244193526850/task/1210689664512026?focus=true
  color?: string;
  dropdown?: boolean;
  capitalized?: boolean;
  className?: string;
  icon?: React.ReactElement | null;
}) => (
  <>
    <Button
      {...other}
      size="sm"
      shape="round"
      iconRight={dropdown ? <Icon icon="caretDown" size="sm" /> : undefined}
      className={clsx(
        'wk-state-pill',
        `button-${color}`,
        'wk-state-pill--text-style',
        className,
        {
          'wk-state-pill--default-cursor': !dropdown,
        }
      )}
    >
      {children}
    </Button>
    <style jsx>{`
      :global(.wk-button.wk-state-pill.wk-state-pill--text-style) {
        font-size: ${fontSize};
        ${capitalized ? 'text-transform: capitalize;' : ''}
        padding: 0 12px;
      }

      :global(.wk-button.wk-state-pill.wk-state-pill--default-cursor) {
        cursor: default;
      }

      :global(.wk-button.wk-state-pill .wk-button__content + .wk-button__icon) {
        margin-left: 0.7em;
      }

      :global(.wk-button.wk-state-pill.wk-state-pill--text-style:active) {
        box-shadow: none;
      }

      :global(
        .wk-button.wk-state-pill.wk-state-pill--text-style:focus-visible
      ) {
        outline: none;
      }
    `}</style>
  </>
);
